import { useEffect, useState } from "react";

const ApartmentBeforeContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      overflowX: "hidden",
    },

    title: {
      textAlign: "center",
      fontSize: "clamp(26px, 4vw, 44px)",
      fontWeight: 500,
      lineHeight: 1.2,
      marginBottom: isMobile ? "30px" : "50px",
    },

    highlight: { color: COLORS.primaryGreen },

    /* ================= SECTION 1 ================= */
    sectionOne: {
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    leftImageWrap: {
      flex: "1 1 420px",
      display: "flex",
      justifyContent: "center",
    },

    imageStack: {
      position: "relative",
      width: "100%",
      maxWidth: isMobile ? "280px" : "420px",
    },

    imageTiltShade: {
      position: "absolute",
      top: isMobile ? "8px" : "12px",
      left: isMobile ? "15px" : "36px",
      transform: isMobile ? "rotate(2deg)" : "rotate(5deg)",
      width: "100%",
      height: isMobile ? "84%" : "100%",
      background: "#e5e5e5",
      borderRadius: "38px",
      zIndex: 0,
    },

    leftImage: {
      position: "relative",
      width: "100%",
      borderRadius: "35px",
      zIndex: 1,
    },

    rightContent: {
      marginTop: isMobile ? "-65px" : "",
      flex: "1 1 480px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    description: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.8,
      color: "#555",
      marginBottom: "25px",
    },

    bottomRow: {
      display: "flex",
      gap: "20px",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    highlightCard: {
      background: "#3b3b3b",
      color: "#fff",
      padding: "20px",
      borderRadius: "16px",
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      width: isMobile ? "88%" : "100%",
    },

    smallImage: {
      width: isMobile ? "100%" : "200px",
      maxWidth: "320px",
      borderRadius: "16px",
      objectFit: "cover",
    },

    /* ================= SECTION 2 ================= */
    sectionTwo: {
      display: "flex",
      gap: "40px",
      marginTop: "50px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    modernLeft: {
      flex: "1 1 420px",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      textAlign: isMobile ? "center" : "left",
    },

    modernTitle: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
    },

    modernLeftCard: {
      background: "#f1fbf4",
      borderRadius: "22px",
      padding: "18px",
    },

    modernImage: {
      width: "100%",
      borderRadius: "18px",
      marginBottom: "14px",
    },

    modernCaption: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      color: "#333",
    },

    modernRight: {
      flex: "1 1 520px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    modernDesc: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
      marginBottom: "26px",
    },

    featureGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(140px, 1fr))"
        : "repeat(2, 1fr)",
      gap: "16px",
      justifyItems: "center",
      marginBottom: "28px",
    },

    listItem: {
      fontSize: isMobile ? "15px" : "17px",
      color: "#444",
      lineHeight: 1.7,
    },

    footerText: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Apartment for Sale in Trichy
      </h1>

      {/* SECTION 1 */}
      <div style={styles.sectionOne}>
        <div style={styles.leftImageWrap}>
          <div style={styles.imageStack}>
            <div style={styles.imageTiltShade} />
            <img
              src="https://mithahomes.com/backend/uploads/home/image2.png"
              alt="Apartment for Sale in Trichy"
              style={styles.leftImage}
            />
          </div>
        </div>

        <div style={styles.rightContent}>
          <p style={styles.description}>
            <strong>Discover Your Ideal Apartment for Sale in Trichy with Mitha Homes
            </strong><br /><br />
            Searching for the right apartment? Mitha Homes brings you a collection of well-crafted residences designed for comfortable and modern living. Located in prime areas, our homes offer the perfect balance of convenience, style, and long-term value.
            From compact flats to spacious apartments, Mitha Homes provides thoughtfully planned living spaces that suit every lifestyle and budget. If you’re looking to invest or settle d

          </p>

          <div style={styles.bottomRow}>
            <div style={styles.highlightCard}>
              <strong>Best Apartments for Sale in Trichy – Designed for Modern Living</strong><br /><br />
              Luxury Apartments in Trichy for Comfortable Living<br />
              Upgrade your lifestyle with our luxury apartments in Trichy, built for families who seek comfort and elegance.
              From smart layouts to premium finishes, Mitha Homes ensures every apartment reflects quality and sophistication.
            </div>

            <img
              src="https://mithahomes.com/backend/uploads/home/image3.png"
              alt="Apartment Building Trichy"
              style={styles.smallImage}
            />
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div style={styles.sectionTwo}>
        <div style={styles.modernLeft}>
          <h2 style={styles.modernTitle}>
            3 BHK Luxury Apartment for Sale in Trichy –{" "}
            <span style={{ color: COLORS.primaryGreen }}>
              Book Your Dream Home Today
            </span>
          </h2>

          <div style={styles.modernLeftCard}>
            <img
              src="https://mithahomes.com/backend/uploads/home/image4.png"
              alt="Apartment Project Trichy"
              style={styles.modernImage}
            />
            <p style={styles.modernCaption}>
              Explore our newest developments featuring premium options for apartment sale in Trichy, designed to suit modern needs and budgets. With flexible pricing plans and hassle-free booking processes, finding your ideal home has never been easier.
              Whether you’re buying your first home or making a smart investment, our apartments in Trichy are built to deliver comfort, convenience, and strong long-term returns.

            </p>
          </div>
        </div>

        <div style={styles.modernRight}>
          <p style={styles.modernDesc}>
            <strong>Premium Apartments in Trichy with Top Amenities</strong><br />
            Our apartment sale in Trichy projects are designed to give you more than just a home – a complete lifestyle.
          </p>

          <div style={styles.featureGrid}>
            <div style={styles.listItem}>• Prime city locations with excellent connectivity</div>
            <div style={styles.listItem}>• Modern architecture and high-quality construction</div>
            <div style={styles.listItem}>• 24/7 security and gated community living</div>
            <div style={styles.listItem}>• Ample parking space</div>
            <div style={styles.listItem}>• Children's play area &amp; landscaped surroundings</div>
            <div style={styles.listItem}>• Close to schools, hospitals, and shopping centers</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApartmentBeforeContent;
